var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 21,
    viewBox: "0 0 44 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 42.75,
    height: 20.25,
    rx: 3.75,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1066_2127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6752 16.0881H16.6982L18.5603 5.19775H21.5371L19.6752 16.0881Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4668 5.46364C29.8796 5.24329 28.9483 5 27.7967 5C24.8568 5 22.7866 6.48286 22.7739 8.6029C22.7494 10.1671 24.2561 11.0358 25.3829 11.5574C26.5347 12.0903 26.9262 12.4382 26.9262 12.9132C26.9145 13.6428 25.9955 13.9791 25.1384 13.9791C23.9499 13.9791 23.313 13.8057 22.3452 13.3998L21.9532 13.2258L21.5366 15.6704C22.2348 15.9713 23.5212 16.2383 24.8568 16.25C27.9805 16.25 30.0141 14.7901 30.0382 12.5309C30.0501 11.2911 29.2545 10.3412 27.5393 9.56498C26.4981 9.06669 25.8604 8.7307 25.8604 8.22086C25.8726 7.75738 26.3998 7.28264 27.5751 7.28264C28.5429 7.25939 29.254 7.47944 29.7927 7.69963L30.062 7.81527L30.4668 5.46364Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4233 12.23C34.6685 11.6044 35.6119 9.18299 35.6119 9.18299C35.5995 9.20624 35.8565 8.54581 36.0035 8.14037L36.2116 9.07874C36.2116 9.07874 36.7753 11.6855 36.8978 12.23C36.4325 12.23 35.0113 12.23 34.4233 12.23ZM38.098 5.19775H35.7953C35.0852 5.19775 34.5457 5.39454 34.2393 6.10133L29.8174 16.0879H32.9411C32.9411 16.0879 33.4553 14.7438 33.5659 14.4543C33.9085 14.4543 36.9473 14.4543 37.3881 14.4543C37.4736 14.8366 37.7433 16.0879 37.7433 16.0879H40.4997L38.098 5.19775Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2113 5.19775L11.2958 12.6239L10.9772 11.1178C10.4382 9.37993 8.74778 7.49179 6.86133 6.55296L9.53179 16.0765H12.6799L17.3592 5.19775H14.2113Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58872 5.19775H3.799L3.75 5.4178C7.48628 6.32152 9.96074 8.49992 10.9774 11.1182L9.93616 6.11318C9.76474 5.41764 9.23794 5.2207 8.58872 5.19775Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1066_2127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.75,
    height: 11.25,
    fill: "white",
    transform: "translate(3.75 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.40a70611ee7101a057bc0be1601d9bac.svg";
export { ForwardRef as ReactComponent };